import React from "react";
import Rcm1 from "../assets/Rcm1.png";
import RcmDraw from "./RcmDraw";
import RcmInfographic from "../assets/RcmInfographic.svg";
import RcmPath from "../assets/RcmPath.svg";
import ColourLogo from "../assets/ColourLogo.svg";
import { Phone, Mail } from "lucide-react";
import { Link } from "react-router-dom";

const RcmPage = () => {
  return (
    <div className="min-h-screen scroll-smooth">

      {/* =======================
          HERO SECTION 1024×580
      ======================== */}
     <section className="relative h-[50vh] sm:h-[60vh] flex items-center justify-center text-white overflow-hidden">
        <video
          className="absolute inset-0 w-full h-full object-cover z-0"
          src="/Product780.mp4"
          autoPlay
          muted
          loop
          playsInline
        />

        <div className="absolute inset-0 bg-gradient-to-r from-[#0A1B60] via-[#1F2E8A] to-[#4B0FA3] opacity-40 z-10" />

        <div className="relative z-20 text-center">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold">
            WISE RCM
          </h1>

         <h2
  className="
    uppercase font-extrabold mt-3
    text-white [@media(hover:hover)]:text-transparent
    text-xl sm:text-2xl md:text-4xl lg:text-5xl xl:text-6xl
  "
  style={{
    fontFamily: "Calibri, sans-serif",
    WebkitTextStroke: "1.8px #fff",
  }}
>
  Optimizing Revenue,<br className="sm:hidden" />
  Simplifying Billing
</h2>
        </div>
      </section>

      {/* =======================
          VISION SECTION 1024×580
      ======================== */}
      <section
        className="
          w-[1024px] h-[580px]
          md:w-screen md:h-auto
          bg-white flex items-center justify-center
          px-6
        "
      >
        <div className="max-w-6xl w-full grid grid-cols-1 md:grid-cols-2 gap-10 items-center">

          <p
  className="text-gray-700 text-sm sm:text-base md:text-[26px] text-justify mt-10"
  style={{ lineHeight: "1.5" }}>
  <span className="font-bold text-gray-900">WISE RCM</span> is designed to enhance financial workflows in healthcare 
  institutions by integrating <span className="font-bold text-gray-900">billing, claims management, and payment tracking</span> 
  into a unified system. Our <span className="font-bold text-gray-900">AI-powered automation</span> reduces manual effort, 
  improves accuracy, and ensures compliance with evolving healthcare regulations. 
  <span className="font-bold text-gray-900"> WISE RCM</span> streamlines revenue cycle management by automating 
  <span className="font-bold text-gray-900"> billing, claims processing, and payment workflows</span>—
  ensuring faster reimbursements and reduced revenue leakage.
</p>

          <div className="flex justify-center">
            <img
              src={Rcm1}
              className="max-w-[300px] md:max-w-[360px] object-contain"
            />
          </div>
        </div>
      </section>

      {/* =======================
          INFOGRAPHICS 1024×580
      ======================== */}
      <section
        className="
          w-[1024px] h-[580px]
          md:w-screen md:h-auto
          bg-white flex items-center justify-center
        "
      >
        <img
          src={RcmInfographic}
          className="w-full max-w-[800px] h-auto scale-[0.85]"
        />
      </section>

      {/* =======================
          DRAW SECTION 1024×580
      ======================== */}
      {/* =======================
    BENEFITS SECTION 1024×580
=========================== */}
<section
  className="
    w-[1024px] h-[580px]
    md:w-screen md:h-[580px]
    bg-gradient-to-r from-[#0A0E45] via-[#1E0F78] to-[#4B0EA6]
    text-white 
    flex items-center justify-center 
    overflow-hidden relative
  "
>
  <div className="w-full h-full flex items-center justify-center overflow-hidden">
    {/* Scale Benefits Graphic */}
    <div className="scale-[0.70] sm:scale-[0.80] md:scale-100 origin-center">
      <RcmDraw />
    </div>
  </div>
</section>


      {/* =======================
          PATH SECTION 1024×580
      ======================== */}
      <section
        className="
          w-[1024px] h-[580px]
          md:w-screen md:h-auto
          bg-white flex items-center justify-center
          overflow-hidden
        "
      >
        <img
          src={RcmPath}
          className="w-full max-w-5xl h-auto object-contain scale-[0.70]"
        />
      </section>

      {/* =======================
          FOOTER (AUTO HEIGHT)
      ======================== */}
      {/* 🌈 Footer Curved Section */}
      <section className="relative bg-gradient-to-r from-[#050A3A] via-[#1A0F6B] to-[#3E0E9F] overflow-hidden h-auto !pb-0 !mb-0">

        {/* Curved white background */}
        <div className="absolute top-[160px] left-0 w-full">
          <div
            className="
              bg-white 
              rounded-t-[12rem] 
              sm:rounded-t-[14rem] 
              min-h-[40vh]         /* reduced height—white space fix */
              sm:min-h-[60vh] 
              pb-6                /* reduced padding to remove gap */
            "
          ></div>
        </div>

        {/* Footer Content */}
        <div className="relative z-10 px-6 sm:px-10 md:px-16 lg:px-24 pt-32 pb-10">

          {/* Footer heading */}
          <div className="text-center mt-[120px] mb-10">
            <h2 className="text-4xl sm:text-5xl font-bold mb-2 text-[#6F7DFF]">
              Collaborate for Success
            </h2>
            <p className="text-gray-700 text-lg sm:text-xl font-medium">
              Working together fosters innovation, creativity, and achievement.
            </p>
          </div>

          {/* Footer grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 text-gray-800">

            {/* About us */}
            <div>
              <h3 className="font-bold mb-4 text-gray-900">ABOUT US</h3>
              <img src={ColourLogo} alt="Wissenstil Solutions" className="w-40 mb-4" />
              <p className="mb-4">
                Wissenstil Solutions is a specialized software company driving digital innovation.
              </p>
            </div>

            {/* Services */}
            <div>
              <h3 className="font-bold mb-4 text-gray-900">SERVICES</h3>
              <ul className="space-y-2">
                <li>Image Analysis</li>
                <li>Anomaly Detection</li>
                <li>Medical Coding</li>
              </ul>
            </div>

            {/* Useful links */}
            <div>
              <h3 className="font-bold mb-4 text-gray-900">USEFUL LINKS</h3>
              <ul className="space-y-2">
                {[
                  { name: "About Us", path: "/about" },
                  { name: "Wise Services", path: "/services" },
                  { name: "Wise Products", path: "/products" },
                  { name: "Contact Us", path: "/contact" },
                ].map((link, index) => (
                  <li
                    key={index}
                    className="transition-transform duration-300 hover:translate-x-2"
                  >
                    <Link to={link.path} className="relative hover:text-purple-700">
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h3 className="font-bold mb-4 text-gray-900">CONTACT US</h3>
              <p>
                Wissenstil Solutions Private Ltd.<br />
                Brigade IRV Centre, Floors 09 & 10,<br />
                Whitefield, Bangalore, 560066.
              </p>

              <div className="mt-4 space-y-3">
                <p className="flex items-center space-x-3">
                  <Phone className="w-5 h-5 text-gray-900" />
                  <span className="font-medium text-gray-900">
                    +91 9986158307
                  </span>
                </p>

                <p className="flex items-center space-x-3">
                  <Mail className="w-5 h-5 text-gray-900" />
                  <span className="font-medium text-gray-900">
                    Manish.palliyil@wissenstil.com
                  </span>
                </p>
              </div>
            </div>

          </div>
        </div>
      </section>

    </div>
  );
};

export default RcmPage;